// Movement 4 of 4: free-form suggestion captured for classification (AE-004).
// Source: CogniPrint_Recalibration_Dev_Plan_v1.md §3.7–§3.8 (REC-030, REC-031).

interface Props {
  question: string;
  freeText: string | null;
  softReset?: boolean;
  onFreeTextChange: (text: string) => void;
  onBack: () => void;
  onSubmit: () => void;
}

export function SuggestionBox({
  question,
  freeText,
  softReset,
  onFreeTextChange,
  onBack,
  onSubmit,
}: Props) {
  return (
    <>
      <div className="text-[11px] uppercase tracking-wider text-gold-500 font-semibold mb-1">
        Movement 4 · Open Suggestion
      </div>
      <h3 className="font-heading text-[16px] font-bold text-white mb-4 leading-snug">
        {question}
      </h3>
      <textarea
        placeholder="Anything — big or small."
        value={freeText ?? ''}
        onChange={(e) => onFreeTextChange(e.target.value)}
        rows={5}
        className="w-full rounded-lg text-sm p-3 mb-5"
        style={{
          background: 'rgba(255,255,255,0.02)',
          border: '1px solid rgba(255,255,255,0.08)',
          color: '#e1dfef',
          resize: 'none',
        }}
      />
      <div className="flex items-center justify-between">
        <button onClick={onBack} className="text-xs text-content-muted underline">
          Back
        </button>
        <button
          onClick={onSubmit}
          className="rounded-lg font-semibold text-sm"
          style={{
            padding: '9px 18px',
            background: 'linear-gradient(135deg, #6C5CE7, #A39BE0)',
            color: '#fff',
          }}
        >
          {softReset ? 'Re-anchor my cycle' : 'Apply recalibration'}
        </button>
      </div>
    </>
  );
}
